import { Check, X, Minus } from "lucide-react";

type Cell = boolean | string | "partial";

const rows: { label: string; traditional: Cell; fsbo: Cell; realv3: Cell }[] = [
  { label: "Total cost on a $500k home", traditional: "$30,000", fsbo: "$0 + risk", realv3: "$2,500" },
  
  { label: "Pro photography", traditional: true, fsbo: false, realv3: true },
  { label: "Offer & negotiation help", traditional: true, fsbo: false, realv3: true },
  { label: "Contracts & disclosures handled", traditional: true, fsbo: false, realv3: true },
  { label: "Closing coordination", traditional: true, fsbo: false, realv3: true },
  { label: "Concierge support 7 days/week", traditional: "partial", fsbo: false, realv3: true },
  { label: "1-on-1 founder support", traditional: false, fsbo: false, realv3: true },
  { label: "Lock-in contract", traditional: "6 months", fsbo: "—", realv3: "Cancel anytime" },
];

const renderCell = (v: Cell, highlight = false) => {
  if (v === true) return <Check className={`h-5 w-5 mx-auto ${highlight ? "text-primary" : "text-foreground/60"}`} strokeWidth={2.5} />;
  if (v === false) return <X className="h-5 w-5 mx-auto text-muted-foreground/40" strokeWidth={2} />;
  if (v === "partial") return <Minus className="h-5 w-5 mx-auto text-muted-foreground" strokeWidth={2} />;
  return <span className={`text-sm ${highlight ? "font-semibold text-primary" : "text-foreground"}`}>{v}</span>;
};

const ComparisonTable = () => {
  return (
    <section className="bg-brand-warm-50 py-10 md:py-14 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 space-y-3">
          <span className="text-sm font-medium uppercase tracking-wider text-primary">Compare your options</span>
          <h2 className="text-3xl md:text-5xl font-bold text-foreground">
            See where your money <span className="text-primary">actually goes.</span>
          </h2>
        </div>

        <div className="bg-card border border-border rounded-2xl overflow-hidden shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border">
                  <th className="text-left p-4 md:p-5 text-sm font-medium text-muted-foreground"> </th>
                  <th className="p-4 md:p-5 text-sm font-semibold text-foreground">Traditional Agent</th>
                  <th className="p-4 md:p-5 text-sm font-semibold text-foreground">FSBO alone</th>
                  <th className="p-4 md:p-5 text-sm font-bold text-primary bg-primary/5">REALV3</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={r.label} className={i % 2 === 0 ? "bg-brand-warm-50/40" : ""}>
                    <td className="p-4 md:p-5 text-sm text-foreground font-medium border-b border-border">{r.label}</td>
                    <td className="p-4 md:p-5 text-center border-b border-border">{renderCell(r.traditional)}</td>
                    <td className="p-4 md:p-5 text-center border-b border-border">{renderCell(r.fsbo)}</td>
                    <td className="p-4 md:p-5 text-center border-b border-border bg-primary/5">{renderCell(r.realv3, true)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <p className="text-xs text-muted-foreground text-center mt-4">
          *Illustrative only. Traditional fee assumes 6% commission. Your actual savings will vary.
        </p>
      </div>
    </section>
  );
};

export default ComparisonTable;
